import React, { Component } from 'react';
import BaseModal from '../Modals/BaseModal';

require('./index.scss');

class ErrorNotice extends Component {
    constructor (props) {
        super(props);
    }

    _renderHeader () {
        switch (this.props.route.type) {
        case 'login':
            return 'We were unable to log you in.';
        default:
            return 'We were unable to complete that action.';
        }
    }

    _renderHint () {
        switch (this.props.route.type) {
        case 'login':
            return (
                <span>
                    Typically, this means your mentor.com credentials were entered correctly,{" "}
                    but you do not currently have access to the Time Tracker application.
                </span>
            );
        default:
            return "";
        }
    }

    render () {
        return (
            <BaseModal
                isOpen={true}
                hasCloseButton={false}
                renderWithHeader={true}
                title="Warning"
                shouldCloseOnOverlayClick={false}
            >
                <div className="errorModal container">
                    <h2>{this._renderHeader()}</h2>
                    <p>{this._renderHint()}</p>
                    <p>
                        If you believe this failure to be in error, please{" "}
                        <a href={`mailto:${process.env.TECH_SUPPORT_EMAIL}`}>
                            contact technical support
                        </a>.
                        {(this.props.route.errorId)
                            ? (<span> Please reference error <code>#{this.props.route.errorId}</code>.</span>)
                            : ``
                        }
                    </p>
                </div>
            </BaseModal>
        );
    }
}

export default ErrorNotice;



// WEBPACK FOOTER //
// ./app/components/ErrorNotice/index.jsx